export default {
    EXPENSE_TYPE_REPLACEMENT_TICKET: 0,
};